export default __webpack_public_path__ + "static/media/rocky.41842110.png";